<script>
import axios from 'axios'
import adminTable from './mixins/adminTable'
import { mapGetters } from 'vuex'
import { Event } from 'vue-tables-2'

export default
{
    mixins: [ adminTable ],

    computed: {
        ...mapGetters({
            artists: 'artistList',
            locations: 'locationList',
            categories: 'programcategoriesList',
        })
    },

    methods:
    {
        importPrograms()
        {
            this.importErrors = null
            this.$refs.importer.open()
        },

        doImport()
        {
            if (!this.importModel.xlsx || this.importModel.xlsx.length !== 1)
            {
                this.closeImportForm()
                return
            }

            const formData = new FormData()
            const fileList = this.importModel.xlsx

            Array
                .from(Array(fileList.length).keys())
                .map(x => {
                    formData.append('xlsx', fileList[x], fileList[x].name);
            })

            this.$snotify.async(this.$t('GENERAL.LOADING'), '', () => new Promise((resolve, reject) => {

                axios.post( process.env.API_URL + '/v1/admin/programs/import', formData ).then(({data}) => {
                    if (!data)
                    {
                        this.closeImportForm()
                    } else {
                        this.importErrors = data
                    }
                    this.fetch()
                    this.$store.dispatch('locationFetch')
                    this.$store.dispatch('artistFetch')
                    resolve({
                        title: this.$t('GENERAL.SUCCESS'),
                        body: this.$t('GENERAL.DONE'),
                        config: {
                            timeout: 2000,
                            pauseOnHover: false,
                            showProgressBar: true,
                            closeOnClick: true,
                        },
                    })
                }).catch(e => {
                    this.closeImportForm()
                    this.fetch()
                    reject({
                        title: this.$t('GENERAL.ERROR'),
                        body:  '',
                        config: {
                            timeout: 2000,
                            pauseOnHover: false,
                            showProgressBar: true,
                            closeOnClick: true,
                        },
                    })
                })
            }))


        },

        closeImportForm()
        {
            this.$refs.importer.close()
        },

        emptyPrograms()
        {
            this.$snotify.confirm('Biztos törölni akarod az összes programot ? ', {
                buttons: [
                    { text: this.$t('GENERAL.YES'), action: (toast) => {
                        this.$snotify.remove(toast.id)
                        axios.delete(process.env.API_URL + '/v1/admin/programs/deleteall', {}).then(({data}) => {
                            this.fetch()
                        })
                      }
                    },
                    {
                        text: this.$t('GENERAL.NO'), action: (toast) => this.$snotify.remove(toast.id),
                    },
                ]
            })

        },

        applyArtistFilter(artist)
        {
            this.$store.commit(this.tableName + '/SET_CUSTOM_FILTER', {filter: 'artists', value: artist})
        },

        applyStatusFilter(status)
        {
            this.$store.commit(this.tableName + '/SET_CUSTOM_FILTER', {filter: 'status', value: status})
        },

        applyLocationFilter(location)
        {
            this.$store.commit(this.tableName + '/SET_CUSTOM_FILTER', {filter: 'location', value: location})
        },

        applyCategoryFilter(category)
        {
            this.$store.commit(this.tableName + '/SET_CUSTOM_FILTER', {filter: 'category', value: category})
        },

        deleteMany()
        {
            this.$snotify.confirm(this.$t('GENERAL.DELETE_MODEL', { model: '' + this.checked.length + ' elemet' }), this.$t('GENERAL.DELETE'), {
                buttons: [
                    {text: this.$t('GENERAL.YES'), action: (toast) => {
                        this.$snotify.remove(toast.id)

                        axios.delete(`${process.env.API_URL}/v1/admin/programs`, { params: { models: this.checked }}).then(res => {
                            this.checked = []
                            this.fetch()
                        }).catch(e => {})

                    }, bold: false},
                    {text: this.$t('GENERAL.NO'), action: (toast) => this.$snotify.remove(toast.id) },
                ]
            })
        },

        emptySelected()
        {
            this.checked = []
        }
    },

    data()
    {
        return {
            checked: [],
            importErrors: null,
            data: [],
            url: '/v1/admin/programs',
            tableName: 'tablePrograms',
            emptyModel: { name: null, slug: null, attachments: [], location_id: null, artists: [], start: null, end: null, description: null, long_description: null, on_site: true, on_mobile: true, pinned: false, is_all_day: false, },
            importModel: { xlsx: null },
            columns: [ 'id', 'image', 'name', 'name_en', 'status', 'start', 'end', 'location', 'artists', 'actions' ],
            options: {
                headings: {
                    actions: this.$t('TABLE.ACTIONS'),
                    name: this.$t('PROGRAM.NAME'),
                    start: this.$t('PROGRAM.START'),
                    end: this.$t('PROGRAM.END'),
                    location: this.$t('PROGRAM.LOCATION'),
                    artists: this.$t('PROGRAM.ARTIST'),
                    name_en: this.$t('PROGRAM.NAME_EN'),
                },
                perPage: 50,
                perPageValues: [10, 25, 50, 100, 200, 400],
                saveState: true,
                highlightMatches: true,
                filterByColumn: true,
                columnsDropdown: true,
                toMomentFormat: true,
                filterable: ['name', 'name_en', 'location', 'start'],
                rowClassCallback: function(row) {
                    return row.is_invalid == 1 ? 'red' : ''
                },
                customFilters: [{
                    name: 'artists',
                    callback: function(row, query) {
                        for (let i = 0; i < row.artists.length; ++i)
                        {
                            if (row.artists[i].id == query.id)
                                return true;
                        }
                        return false
                    }
                }, {
                    name: 'category',
                    callback: function(row, query) {
                        for (let i = 0; i < row.program_categories.length; ++i)
                        {
                            if (row.program_categories[i].id == query.id)
                                return true;
                        }
                        return false
                    }
                }, {
                    name: 'location',
                    callback: function(row, query) {
                        if (row.location && row.location.name)
                        {
                            if (row.location.name.indexOf(query.name) !== -1)
                                return true;
                        }
                        return false
                    }
                }, {
                    name: 'status',
                    callback: function(row, query) {
                        const flattened = []
                        if (query.length == 0) return true // YOLO
                        for (let i = 0; i < query.length; ++i)
                            flattened.push(query[i].id)

                        let visible = true

                        if (flattened.includes('site'))
                            visible = visible && row.on_site == 1
                        if (flattened.includes('not_site'))
                            visible = visible && row.on_site == 0

                        if (flattened.includes('mobile'))
                            visible = visible && row.on_mobile == 1
                        if (flattened.includes('not_mobile'))
                            visible = visible && row.on_mobile == 0

                        if (flattened.includes('pinned'))
                            visible = visible && row.pinned == 1
                        if (flattened.includes('not_pinned'))
                            visible = visible && row.pinned == 0

                        if (flattened.includes('location'))
                            visible = visible && ( row.location && row.location.id )
                        if (flattened.includes('not_location'))
                            visible = visible && row.location == null

                        return visible
                    }
                }
                ],
            },
            statusOptions: [
                {
                    id: 'site',
                    label: 'Oldalon',
                },

                {
                    id: 'not_site',
                    label: 'Nincs az Oldalon',
                },

                {
                    id: 'mobile',
                    label: 'Mobilon',
                },

                {
                    id: 'not_mobile',
                    label: 'Nincs mobilon',
                },

                {
                    id: 'pinned',
                    label: 'Kiemelt',
                },

                {
                    id: 'not_pinned',
                    label: 'Nem kiemelt',
                },

                {
                    id: 'location',
                    label: 'Van helyszín',
                },

                {
                    id: 'not_location',
                    label: 'Nincs helyszín',
                },


            ]
        }
    },

    mounted()
    {
        this.$store.dispatch('artistCheck')
    }

}
</script>

<template>
    <div class="container-fluid">
        <div class="form-group row">
            <div class="col-md-4">
                <label for="name" class="control-label text-left">
                    {{ $t('PROGRAM.ARTIST') }}
                </label>
                <v-select :options="artists" label="name" @input="applyArtistFilter">

                </v-select>
            </div>
            <div class="col-md-4">
                <label for="name" class="control-label text-left">
                    {{ $t('WISHLIST.CATEGORIES') }}
                </label>
                <v-select :options="categories" label="name" @input="applyCategoryFilter">

                </v-select>
            </div>
            <!--
            <label for="name" class="col-md-2 control-label text-left">
                {{ $t('PROGRAM.LOCATION') }}
            </label>
            <div class="col-md-4">
                <v-select :options="locations" label="name" @input="applyLocationFilter">

                </v-select>
            </div>
            -->
            <div class="col-md-4">
              <label for="name" class="control-label text-left">
                  {{ $t('PROGRAM.STATUS') }}
              </label>
                <v-select :options="statusOptions" multiple @input="applyStatusFilter">

                </v-select>
            </div>
        </div>
        <mv-modal ref="form">
            <span slot="header">{{ $t('GENERAL.EDIT') }}</span>
            <mv-program-form :model="model" :edit="formEdit" @save="saveForm"></mv-program-form>
            <div slot="footer">
                <button class="btn btn-success" @click="closeForm">{{ $t('GENERAL.CANCEL') }}</button>
                <button class="btn btn-primary" @click="saveForm">{{ $t('GENERAL.SAVE') }}</button>
            </div>
        </mv-modal>
        <mv-modal ref="importer">
            <span slot="header">{{ $t('GENERAL.IMPORT') }}</span>
            <mv-program-import-form :model="importModel" @save="doImport" @close="closeImportForm" :errors="importErrors"></mv-program-import-form>
            <div slot="footer" v-if="!importErrors">
                <button class="btn btn-success" @click="closeImportForm">{{ $t('GENERAL.CANCEL') }}</button>
                <button class="btn btn-primary" @click="doImport">{{ $t('GENERAL.IMPORT') }}</button>
            </div>
        </mv-modal>
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>{{ $t('MENU.PROGRAMS') }}</h4>
                    </div>

                    <div class="col-sm-2 text-right">
                        <button class="btn btn-xs btn-success" @click="importPrograms">
                            <icon name="upload"></icon>
                        </button>
                        <button class="btn btn-xs btn-warning" @click="newModel">
                            <icon name="plus"></icon>
                        </button>
                        <button class="btn btn-xs btn-success" @click="exportFile">
                            <icon name="download"></icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <div  v-if="checked && checked.length > 0" class="text-center">
                    <button class="btn btn-xs btn-warning" @click="deleteMany">
                        <span>
                            {{ checked.length }} Elem Törlése
                        </span>
                    </button>

                    <button class="btn btn-xs btn-success" @click="emptySelected">
                        <span>
                            {{ $t('GENERAL.CANCEL') }}
                        </span>
                    </button>
                </div>
                <v-client-table :data="data" :columns="columns" :options="options" :name="tableName" ref="table">
                    <div slot="id" slot-scope="props">
                        <input type="checkbox" v-model="checked" :value="props.row.id">
                        {{ props.row.id }}
                    </div>
                    <div slot="actions" slot-scope="props" class="text-center">
                        <button class="btn btn-xs btn-warning" @click="delModel(props.row, props.row.name)">
                            <icon name="remove"></icon>
                        </button>
                        <button class="btn btn-xs btn-primary" @click="updateModel(props.row)">
                            <icon name="edit"></icon>
                        </button>
                    </div>

                    <div slot="image" slot-scope="props">
                        <div v-if="props.row.attachments && props.row.attachments.length > 0">
                            <img :src="props.row.attachments[0].thumbnail_url">
                        </div>
                    </div>

                    <div slot="status" slot-scope="props">

                        <div class="label" :class="{ 'label-warning': !props.row.on_mobile, 'label-success': props.row.on_mobile}">
                            Mobilon
                        </div>

                        <div class="label" :class="{ 'label-warning': !props.row.on_site, 'label-success': props.row.on_site}">
                            Oldalon
                        </div>

                        <div class="label label-success" v-if="props.row.pinned">
                            Kiemelt
                        </div>
                    </div>

                    <div slot="location" slot-scope="props">
                        <div v-if="props.row.location">
                            {{ props.row.location.name }}
                        </div>
                    </div>

                    <div slot="artists" slot-scope="props">
                        <div v-for="artist in props.row.artists" :key="artist.id">
                            <div>
                                <img v-if="artist.attachments && artist.attachments.length > 0" :src="artist.attachments[0].thumbnail_url">
                                <div class="label label-primary">
                                    {{ artist.name }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div slot="start" slot-scope="props">
                        <div v-if="props.row.start">
                            {{ props.row.start | shortDate }}
                        </div>
                    </div>

                    <div slot="end" slot-scope="props">
                        <div v-if="props.row.end">
                            {{ props.row.end | shortDate }}
                        </div>
                    </div>

                    <div slot="child_row" slot-scope="props">
                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <strong>
                                    {{ $t('PROGRAM.DESCRIPTION')}}
                                </strong>
                            </div>
                            <div class="panel-body">
                                <div>
                                    {{ props.row.description }}
                                </div>
                            </div>
                        </div>

                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <strong>
                                    {{ $t('PROGRAM.LONG_DESCRIPTION')}}
                                </strong>
                            </div>
                            <div class="panel-body">
                                <div>
                                    {{ props.row.long_description }}
                                </div>
                            </div>
                        </div>
                    </div>
                </v-client-table>
            </div>
        </div>
    </div>
</template>




// WEBPACK FOOTER //
// src/pages/Programs.vue